import { useState } from "react";
import { Plus, Trash2, Pencil, Loader, ChevronDown } from "lucide-react";
import DailogAddAndEditShiftGroup from "./dialogStaff/DailogAddAndEditShiftGroup";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { useLocation } from "react-router-dom";

import { AppLog } from "services";
import appStore from "store/appStore";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "components/ui/collapsible";
import { Button } from "components/ui/button";
import useStaffAction from "./StaffAction";
interface shiftProps {
  userShopShiftGroup: any;
  setUserShopShiftGroup: any;
  shiftGroupId: any;
  setShiftGroupId: any;
}
export default function Shift({ userShopShiftGroup, setUserShopShiftGroup, shiftGroupId, setShiftGroupId }: shiftProps) {
  const { shiftActive, setShiftActive, clearDatashift, setLoadingDeleteShit } = useStaffAction();

  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [isDailogAddOrEditShiftGroup, setIsDailogAddOrEditShiftGroup] = useState<boolean>(false);
  const { showDialogConfirm } = appStore();
  const [isUpdateShift, setIsUpdateShift] = useState<any>(null);
  // -----delete shift----

  const onSubmitDeleteShift = async (id: any) => {
    setLoadingDeleteShit(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopShiftGroup;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        shift_group_id: id,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setLoadingDeleteShit(false);

            setUserShopShiftGroup((prevItemGroups: any) => {
              const shiftData = responses.user_shop_shift_group;
              // Remove the deleted shift by filtering it out
              const updatedData = (prevItemGroups || []).filter((item: any) => item.id !== shiftData.id);
              return updatedData;
            });
          } else {
          }
          // setLoadingSubmit(false);
        })
        .catch((err) => {
          setLoadingDeleteShit(false);
        });
      // setLoadingSubmit(false);
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeleteShift]`,
        status: StatusMsg.error,
        error,
      });
      // setLoadingSubmit(false);
    }
  };
  const [isCreateShift, setIsCreateShift] = useState<boolean>(false);

  const formatTime = (time: string | null) => {
    if (!time) return ""; // Handle null or empty values

    const [hours, minutes] = time.split(":").map(Number); // Split time into hours and minutes
    const period = hours >= 12 ? "PM" : "AM"; // Determine AM or PM
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format

    return `${formattedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };
  const [isOpen4, setIsOpen4] = useState(true);

  return (
    <>
      <div className=" py-1 rounded-md ">
        <Collapsible open={isOpen4} onOpenChange={setIsOpen4} className="w-full ">
          <div className="flex items-center justify-between">
            <h4 className="text-xl font-semibold mb-3 mt-1 text-blue-600  ">Attendance Management</h4>
            <CollapsibleTrigger asChild>
              <Button variant="ghost" size="sm">
                <ChevronDown className="h-4 w-4" />
                <span className="sr-only">Toggle</span>
              </Button>
            </CollapsibleTrigger>
          </div>

          <CollapsibleContent className="">
            <div className="grid lg:grid-cols-5 gap-2">
              {userShopShiftGroup?.map((item: any, index: any) => (
                <button
                  key={index}
                  onClick={() => {
                    setShiftActive(item.id);
                    setShiftGroupId(item.shift_group_id);
                  }}
                  className={`border px-4 py-2  rounded-lg text-sm font-semibold ${
                    shiftGroupId === item.shift_group_id ? "bg-primary text-white border-transparent" : "dark:bg-transparent border border-gray-300"
                  } `}
                >
                  <div className="flex items-center justify-between gap-5 ">
                    <div className="w-full group ">
                      <div className="flex justify-between items-center">
                        <label className="block mb-1 text-md font-medium text-start">{item.local_description}</label>
                        <div className="flex opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:scale-100  items-center gap-2     ">
                          <div className="flex items-center justify-center border border-gray-300 p-1 rounded-full">
                            <Pencil
                              onClick={(event) => {
                                setIsUpdateShift(item.id);
                                event.stopPropagation();
                                setIsDailogAddOrEditShiftGroup(true);
                              }}
                              className=" w-5 h-5 "
                            />
                          </div>
                          <div className="flex items-center justify-center border border-gray-300 p-1 rounded-full">
                            <Trash2
                              onClick={(event) => {
                                event.stopPropagation();
                                showDialogConfirm({
                                  titileButtonSubmit: "Yes, Delete",
                                  titileButtonCancel: "No, Cancel",
                                  title: "Delete",
                                  message: "Do you want to delete?",
                                  onSubmit() {
                                    onSubmitDeleteShift(item.shift_group_id);
                                  },
                                });
                              }}
                              className=" w-5 h-5"
                            />
                          </div>
                        </div>
                      </div>
                      {item.working_hours && (
                        <div className="flex flex-col justify-between items-start w-full gap-2 py-2  ">
                          {item.working_hours.map((data: any, index: any) => {
                            return (
                              <div key={index}>
                                <div className="flex  items-start text-start gap-1 mt-1 rounded-md ">
                                  <p className="text-start">{data.weekday.slice(0, 3)},</p>

                                  <div className="flex items-center gap-1">
                                    {!data.starting_time || !data.ending_time ? (
                                      <p className="text-red-500">OFF</p>
                                    ) : (
                                      <>
                                        <p className={` dark:text-white text-[12px] ${shiftActive === item.id ? "text-white" : ""}`}>{formatTime(data.starting_time)}</p>
                                        <span className={`text-gray-300 ${shiftActive === item.id ? "text-gray-300" : ""}`}>-</span>
                                        <p className={` dark:text-white text-[12px] ${shiftActive === item.id ? "text-white" : ""}`}>{formatTime(data.ending_time)}</p>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </button>
              ))}
              <button
                onClick={() => {
                  setIsDailogAddOrEditShiftGroup(true);
                  setIsCreateShift(true);
                  clearDatashift();
                  setIsUpdateShift(null);
                }}
                className={` border border-gray-200 bg-gray-100 dark:bg-black  px-4 py-2 h-[300px] flex items-center justify-center  rounded-lg text-sm font-semibold  `}
              >
                <label
                  className=" p-1 mx-auto z-50 top-2 right-2 text-white group bg-blue-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                >
                  <Plus className="text-sm cursor-pointer  dark:text-white" />
                </label>
              </button>
            </div>
          </CollapsibleContent>
        </Collapsible>
      </div>
      <DailogAddAndEditShiftGroup
        setUserShopShiftGroup={setUserShopShiftGroup}
        userShopShiftGroup={userShopShiftGroup}
        isUpdateShift={isUpdateShift}
        setIsUpdateShift={setIsUpdateShift}
        isCreateShift={isCreateShift}
        isDailogAddOrEditShiftGroup={isDailogAddOrEditShiftGroup}
        setIsDailogAddOrEditShiftGroup={setIsDailogAddOrEditShiftGroup}
      />
    </>
  );
}
